<template>
  <div class="tests single-step">
    <div class="heading">
      <h2>
        {{$ml.get(`Tests`)}}
      </h2>
      <info-tip :title="$ml.get(`Here you need to attach your tests to the program that you are creating by clicking on it. If you did not uploaded any test yet do it now by clicking the button “add test”`)"/>
    </div>
    <div class="test-type-switcher">

      <app-radio-group v-model="testType" :items="tests"/>

      <div class="add-test">
        <!-- <btn>reload tests</btn> -->
        <app-btn icon="add" styling="outline" to="/dashboard/tests">
          {{ $ml.get(`ADD TEST`) }}
        </app-btn>
      </div>
    </div>

    <water v-if="testType == 'water'" @loadProgram="loadProgram"/>
    <soil v-if="testType == 'soil'" @loadProgram="loadProgram"/>
    <tissue v-if="testType == 'tissue'" @loadProgram="loadProgram"/>
    <media v-if="testType == 'media'" @loadProgram="loadProgram"/>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import API from '@/api'
import Water from './Water'
import Tissue from './Tissue'
import Soil from './Soil'
import Media from './Media'

export default {
  data() {
    return {
      testType: ''
    }
  },
  methods: {
    next() {

      let program = this.$store.getters['program/data'];

      if(program.soilTest && !program.soilTestId) {
        this.$store.dispatch('program/canGoToNextStep', false);
        this.$store.commit('program/steps/setCurrentStep', 'general-settings');
      }

      else if(program.waterTest && !program.waterTestId){
        this.$store.dispatch('program/canGoToNextStep', false);
        this.$store.commit('program/steps/setCurrentStep', 'general-settings');
      }

      else if(program.tissueTest && !program.tissueTestId){
        this.$store.dispatch('program/canGoToNextStep', false);
        this.$store.commit('program/steps/setCurrentStep', 'general-settings');
      }
      
      else if(program.mediaAnalysis && !program.mediaAnalysisId){
        this.$store.dispatch('program/canGoToNextStep', false);
        this.$store.commit('program/steps/setCurrentStep', 'general-settings');
      }
      
      else {
        this.$store.dispatch('program/canGoToNextStep', true);
        this.$store.dispatch('program/steps/setCurrentStep', 'tests');
      }
    },
    loadProgram() {
      this.$emit('loadProgram', this.$route.params.programId)
    }
  },
  created() {
    this.testType = this.tests[0].key;
    let program = this.$store.getters['program/data'];

      // if(program.soilTest && !program.soilTestId) {
      //   this.$notify({
      //     group: 'notices',
      //     title: this.$ml.get(`You must select soil test to proceed`),
      //     type: 'error',
      //   });
      // }

      // if(program.waterTest && !program.waterTestId){
      //   this.$notify({
      //     group: 'notices',
      //     title: this.$ml.get(`You must select water test to proceed`),
      //     type: 'error',
      //   });
      // }

      // if(program.tissueTest && !program.tissueTestId){
      //   this.$notify({
      //     group: 'notices',
      //     title: this.$ml.get(`You must select tissue test to proceed`),
      //     type: 'error',
      //   });
      // }
      
      // if(program.mediaAnalysis && !program.mediaAnalysisId){
      //   this.$notify({
      //     group: 'notices',
      //     title: this.$ml.get(`You must select media analysis to proceed`),
      //     type: 'error',
      //   });
      // }
  },
  components : {
    Water,
    Soil,
    Tissue,
    Media
  },
  computed: {
    tests() {
      const tests = this.$store.getters['program/tests/tests'];
      return tests.map(n => {
        return {
          key: n,
          label: this.$ml.get(n.toUpperCase()),
        };
      });
    }
  },
  updated() {
    this.next();
  }


}
</script>

<style lang="scss" scoped>
.tests {
  &::v-deep {
    .a-row {
      display: flex;
      flex-direction: row;
      align-items: center;
      border-bottom: 1px solid #E4E5E6;
      border-top: 1px solid transparent;
      padding: 12px 0;
      color: #4C5056;
      margin-top: 6px;
      margin-bottom: 6px;

      .first {
        flex-basis: 60%;
        padding-left: 32px;
      }
      .second {
        flex-basis: 40%;
        padding: 0 16px;
      }
      .third {
        flex-basis: 30%;
        padding-left: 16px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding-right: 16px;
        align-items: center;

        .remove-test {
          border: none;
          background-color: transparent;
          color: #fff;
          cursor: pointer;
          position: relative;
          padding: 0;
          padding-right: 16px;
          height: 100%;
          transition: .3s;
          i {
            // position: absolute;
            // transform: translate(-50%,-50%);

          }
          &:hover {
            i {
              // transform: rotate(190deg) translate(-50%,-50%);
            }
            // transform: rotate(180deg)
          }
        }
      }
      &.heading {
        color: #8B8D91;
        font-size: 12px;
        padding: 6px 0;
        display: flex;
        align-items: center;
        flex-direction: row;
        justify-content: flex-start;
      }
      &.is_active {
        color: #fff;
        background-color: $mainGreen;
        box-shadow: 0px 2px 12px rgba(73, 125, 56, 0.5);
        border-radius: 5px;
        border-bottom-width: 0;
        + .test {
          border-top-color: #E4E5E6;
        }
      }
      &.test {
        cursor: pointer;
        // padding: 20px 0;
        height: 70px;
      }

    }
  }

  .heading {
    color: #8B8D91;
    font-size: 12px;
    // padding: 6px 0;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: flex-start;

    h2 {
      width: auto !important;
    }
  }

  .test-type-switcher {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 32px;

    // .buttons {
    //   border-radius: 5px;
    //   overflow: hidden;

    //   button {
    //     border-width: 0;
    //     color: #8B8D91;
    //     background-color: #E4E5E6;
    //     font-size: 12px;
    //     padding: 8px 32px;
    //     font-weight: 500;
    //     border-right: 1px solid #fff;
    //     cursor: pointer;
    //     text-transform: uppercase;

    //     &.is_active, &:hover {
    //       color: #fff;
    //       background-color: $mainGreen;
    //     }
    //   }
    // }
    .add-test {
      .step-btn {
        font-size: 12px;
      }
    }
  }
  @media (max-width: 768px) {
    .test-type-switcher {
      flex-direction: column;
      align-items: flex-start;
      // .buttons {
      //   margin-bottom: 16px;
      //   width: 100%;
      //   display: flex;
      //   flex-direction: row;
      //   button {
      //     flex-basis:33.3%;
      //     padding: 8px 0;
      //     text-align: center;
      //   }
      // }
    }
  }
}
</style>
